import styled from 'styled-components';

export const Wrapper = styled.div`
  div::before {
    content: '*';
    color: red;
  }
`;
